export let BusinessPropertyName = /*#__PURE__*/function (BusinessPropertyName) {
  BusinessPropertyName["CANCELLATION_POLICY"] = "cancellationPolicy";
  BusinessPropertyName["DEFAULT_TIMEZONE"] = "defaultTimezone";
  BusinessPropertyName["CLIENT_CAN_CHANGE_TIMEZONE"] = "clientCanChangeTimezone";
  BusinessPropertyName["MULTI_SERVICES_APPOINTMENTS"] = "isMultiServicesAppointmentsEnable";
  return BusinessPropertyName;
}({});
const isGetAggregatedInfoResponse = businessResponse => {
  return 'infoView' in businessResponse;
};
export const getCustomProperties = businessResponse => {
  var _businessResponse$bus;
  return isGetAggregatedInfoResponse(businessResponse) ? businessResponse.customProperties || [] : ((_businessResponse$bus = businessResponse.businessProperties) == null ? void 0 : _businessResponse$bus.customProperties) || [];
};
export const getBusinessInfo = businessResponse => isGetAggregatedInfoResponse(businessResponse) ? businessResponse.infoView : businessResponse.info;
export const getPropertyValue = (businessResponse, propertyName) => {
  var _getCustomProperties$;
  return (_getCustomProperties$ = getCustomProperties(businessResponse).find(businessProperty => businessProperty.propertyName === propertyName)) == null ? void 0 : _getCustomProperties$.value;
};
export const isPropertyEnabled = (businessResponse, propertyName) => getPropertyValue(businessResponse, propertyName) === 'true';
//# sourceMappingURL=businessInfo.js.map